import { render, staticRenderFns } from "./ChooseMethods.vue?vue&type=template&id=51157244&scoped=true&"
import script from "./ChooseMethods.vue?vue&type=script&lang=js&"
export * from "./ChooseMethods.vue?vue&type=script&lang=js&"
import style0 from "./ChooseMethods.vue?vue&type=style&index=0&id=51157244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51157244",
  null
  
)

export default component.exports